export function parseCertificateElementHTML({html, getValue}) {
  const $html = html.clone()
  $html.find("var").each(function (index, el) {
    const $el = $(el);
    const dynamicInputId = $el.data().dynamic.id;
    const value = getValue(dynamicInputId)
    $el.removeClass("repeatable")
    $el.removeClass("pill fr-deletable")
    $el.html(value);
  });

  return $html.html();
}
